import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AssessmentManagerListItem } from '../../_models/assessmentManager';
import { Project } from '../../_models';
import { AssessmentManagerService, ProjectService } from '../../_services';

@Component({
  standalone: false,
  selector: 'assessment-manager-list',
  templateUrl: './assessment-manager-list.component.html',
  styleUrls: ['./assessment-manager-list.component.scss']
})
export class AssessmentManagerListComponent implements OnInit {
  projectId: number;
  project: Project;
  assessments: AssessmentManagerListItem[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private assessmentManagerService: AssessmentManagerService,
    private projectService: ProjectService
  ) {
    this.projectId = +this.route.snapshot.params['projectId'];
  }

  ngOnInit() {
    this.load();
  }

  load() {
    const requests = [
      this.assessmentManagerService.getProjectAssessments(this.projectId, 3),
      this.projectService.getById(this.projectId)
    ];

    forkJoin(requests).subscribe((data: any[]) => {
      this.assessments = data[0] || [];
      this.project = data[1];
    });
  }

  createAssessment() {
    this.router.navigate(['/projects/project', this.projectId, 'assessments', 'new']);
  }

  viewAssessment(assessment: AssessmentManagerListItem) {
    this.router.navigate(['/projects/project', this.projectId, 'assessments', assessment.assessmentId]);
  }

  editAssessment(assessment: AssessmentManagerListItem) {
    this.router.navigate(['/projects/project', this.projectId, 'assessments', assessment.assessmentId, 'edit']);
  }

  backToProject() {
    this.router.navigate(['/projects/project', this.projectId]);
  }
}
